export function isPOJO(obj) {
    let proto;
    return (obj &&
        typeof obj == 'object' &&
        ((proto = Object.getPrototypeOf(obj)) === Object.prototype || proto == null));
}
export function forEach(obj, callback, context) {
    let prop;
    // Use for .. in since we need enumerable properties from the prototype chain
    for (prop in obj)
        try {
            Function.prototype.call.call(callback, context, obj[prop], prop, obj);
        }
        catch (e) {
            /* skip over errors */
        }
}
//# sourceMappingURL=object_helpers.js.map